import palette from "../palette";

export default {
  root: {
    fill: palette.primary.main,
  },
};
